import { useMemo } from 'react';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../store';
import { selectCurrentUser } from '../slices';
import { selectFeaturedProperties, selectRecentProperties } from '../slices/property.slice';

export const useAppDispatch = () => useDispatch<AppDispatch>();

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export const useAuth = () => {
  const user = useAppSelector(selectCurrentUser);
  return useMemo(() => ({ user }), [user])
}

export const useProperties = () => {
  const recentProperties = useAppSelector(selectRecentProperties);
  const featuredProperties = useAppSelector(selectFeaturedProperties);
  return useMemo(() => ({
    recentProperties,
    featuredProperties
  }), [featuredProperties, recentProperties]);
}

export const useLogout = () => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('user');
  window.location.href = '/';
}